<script lang="ts">
    import {afterUpdate} from 'svelte';
    import KpCollapsibleButtonMenu from '../collapsible-button-menu/KpCollapsibleButtonMenu.svelte';

    let buttonPanel: Element | undefined;
    let buttonPanelVisible = false;

    afterUpdate(() => {
        const listOfButtons = buttonPanel?.querySelectorAll<HTMLElement>('button, a.btn');
        buttonPanelVisible = Array.from(listOfButtons ?? []).some((button) => isVisible(button));
    });

    function isVisible(element: HTMLElement) {
        return !!(element.offsetWidth || element.offsetHeight);
    }
</script>

<div class="kp-collapsible-menu-wrapper">
    <div class="menu-wrapper-main">
        <slot name="main"/>
    </div>

    {#if $$slots.menu}
        <div class="menu-wrapper-menu buttonsPanel" class:button-panel-visible={buttonPanelVisible} class:button-panel-not-visible={!buttonPanelVisible}>
            <KpCollapsibleButtonMenu let:collapsed let:state>
                <div bind:this={buttonPanel}>
                    <slot name="menu" {collapsed} {state}/>
                </div>
            </KpCollapsibleButtonMenu>
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "src/shared/ui-widgets/collapsible-button-menu/collapsible-menu.constants.less";

    .kp-collapsible-menu-wrapper {
        display: grid;
        grid-template-columns: auto @collapsed-width;
        border: 1px solid @themed-border-default;
        border-radius: @border-radius-large;

        .menu-wrapper-main {
            grid-column: 1 / span 1;
            grid-row: 1;
            width: 100%;
            padding: @spacing-m @spacing-ml;
        }

        .menu-wrapper-menu {
            grid-column: 2 / span 1;
            grid-row: 1;
            position: relative;
            justify-self: end;

            &.button-panel-not-visible {
                visibility: hidden;
            }

            &.button-panel-visible {
                visibility: visible;
            }
        }
    }

    :global {
        .kp-collapsible-menu-wrapper .menu-wrapper-menu .side-bar {
            border: none;
            border-left: 1px solid @themed-border-default;
            border-top-right-radius: @border-radius-large;
            border-bottom-right-radius: @border-radius-large;
        }
    }
</style>